(() => {
  const notice = document.querySelector('[data-simple-cookie-notice]');
  if (!notice || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  const closeButton = notice.querySelector('[data-simple-cookie-notice-close]');
  let consentPending = false;
  let listenersActive = false;

  const removeInteractionListeners = () => {
    if (!listenersActive) return;
    document.removeEventListener('pointerdown', grantConsent, true);
    document.removeEventListener('keydown', handleKeydown, true);
    listenersActive = false;
  };

  const hideNotice = () => {
    notice.hidden = true;
    removeInteractionListeners();
  };

  const grantConsent = () => {
    if (consentPending || notice.hidden || !window.Shopify.customerPrivacy) return;
    consentPending = true;
    removeInteractionListeners();

    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: true,
        marketing: true,
        preferences: true,
      },
      hideNotice
    );
  };

  const handleKeydown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') grantConsent();
  };

  const showNoticeIfRequired = () => {
    const privacy = window.Shopify.customerPrivacy;
    if (!privacy) {
      hideNotice();
      return;
    }

    const visitorConsent = privacy.currentVisitorConsent();
    const consentWasDecided = ['analytics', 'marketing', 'preferences'].every(
      (purpose) => visitorConsent[purpose] === 'yes' || visitorConsent[purpose] === 'no'
    );

    if (!privacy.shouldShowBanner() || consentWasDecided) {
      hideNotice();
      return;
    }

    notice.hidden = false;
    document.addEventListener('pointerdown', grantConsent, true);
    document.addEventListener('keydown', handleKeydown, true);
    listenersActive = true;
  };

  closeButton?.addEventListener('click', grantConsent);

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error) return;
      showNoticeIfRequired();
    }
  );
})();
